import { useContext, useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import LoadingSpinner from "../../../components/LoadinSpinner";
import TitlePage from "../../../components/TitlePage";
import ResponsiveDataTable from "../../../components/DataTable";
import { useNavigate } from "react-router-dom";
import axios from 'axios';
import { ConsultaAPI_URL } from "../../../../backend/ConsultaAPI";

function handleColumnId(item) {
    const isHabilitado = item.value;
    return <>
        <p>{item.value}</p>
        <p><strong>Nome: </strong>{item.row.original.nome}</p>
        <p><strong>E-mail: </strong>{item.row.original.email}</p>
    </>
}

function handleColumnHabilitado(item) {
    const isHabilitado = item.value;
    return isHabilitado ? 'SIM' : 'NÃO';
}

function handleColumnPerfil(item) {
    const perfil = JSON.parse(item.value || '[]');
    return perfil.text ? perfil.text : '' 
}

function ListaUsuarios() {
    var [carregar, setCarregar] = useState(false);
    var [dataGrid, setDataGrid] = useState([]);
    const navigate = useNavigate();

    const columns = [
        {
          Header: 'ID',
          accessor: 'usuario',
          Cell: handleColumnId,
        },
        {
          Header: 'Perfil',
          accessor: 'perfil',        
          Cell: handleColumnPerfil
        },
        {
          Header: 'Habilitado',
          accessor: 'habilitado',
		  Cell: handleColumnHabilitado
        }
    ]

    useEffect(() => {
		const fetchData = async () => {
			try {
				// Construct the public URL for the JSON file
				const jsonUrl = `usuarioSistema`;				
				const response = await ConsultaAPI_URL(jsonUrl);
				
				const data = await response;
				
				// Set the data in the component's state
				setDataGrid(data.usuarios)
				} catch (error) {
				console.error('Error fetching JSON:', error);
			}
		};
	
		fetchData();
    }, []);

    const handleAlterar = (row) =>{
        navigate(`./Alterar/${row.values.usuario}`)
    }

    return (
    <>
        <Row>
            <LoadingSpinner isLoading={carregar}/>
            <Col md="12" xs="12">
                <TitlePage text="Usuários"/>
            </Col>
            { dataGrid.length > 0 &&
                <Col md="12" xs="12">
                    <ResponsiveDataTable 
                        columns={columns} 
                        data={dataGrid} 
                        buttons= {[
                            {isAlterar: true, action: handleAlterar, label: "Alterar", icone: "MdOutlineEditNote"} 
                        ]}
                    />
                </Col>
            }
        </Row>
        </>
    );
}

export default ListaUsuarios;